var Helpers = { }

Helpers.isDescendant = function(parent, child) {
	if(parent==null) return false;
	var node = child.parentNode;
	while(node !== null) {
		if(node === parent) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
}

Helpers.appendClass = function(classes,classToAdd) {
	var arr = classes.split(" ");
	if(arr.indexOf(classToAdd)===-1) {
		return classes+" "+classToAdd;
	}
	return classes; //class already there
}
Helpers.removeClass = function(classes,classToRemove) {
	var arr = classes.split(" ");
	if(arr.indexOf(classToRemove)===-1) return classes; //nothing to remove
	
	arr.splice(arr.indexOf(classToRemove),1);
	return arr.join(" ");
}

Helpers.toggleArrayValue = function(array,value) {
	var index = array.indexOf(value);
	
	if(index === -1) { //not in array
		array.push(value);
	} else { //already in array
		array.splice(index, 1);
	}
	return array;
}

Helpers.appendArrayNoDuplicates = function(array,toAppend) {
	if(array.indexOf(toAppend)===-1) array.push(toAppend);
	return array;
}

Helpers.removeArrayByValue = function(array,toRemove) {
	var index = array.indexOf(toRemove);
	while (index !== -1) {
		array.splice(index, 1);
		index = array.indexOf(toRemove);
	}
	return array;
}

Helpers.findArrayByID = function(array,id) {
	for(var i=0;i<array.length;i++) {
		if(array[i].id===id) return array[i];
	}
	return null;
}

Helpers.cloneObject = function(obj) {
	//http://stackoverflow.com/questions/728360/most-elegant-way-to-clone-a-javascript-object
	var copy;

	// Handle the 3 simple types, and null or undefined
	if (null == obj || "object" !== typeof obj) return obj;

	// Handle Date
	if (obj instanceof Date) {
		copy = new Date();
		copy.setTime(obj.getTime());
		return copy;
	}

	// Handle Array
	if (obj instanceof Array) {
		copy = [];
		for (var i = 0, len = obj.length; i < len; i++) {
			copy[i] = Helpers.cloneObject(obj[i]);
		}
		return copy;
	}

	// Handle Object
	if (obj instanceof Object) {
		copy = {};
		for (var attr in obj) {
			if (obj.hasOwnProperty(attr)) copy[attr] = Helpers.cloneObject(obj[attr]);
		}
		return copy;
	}
}

export default Helpers;



// WEBPACK FOOTER //
// ./src/Helpers.js